<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <input
          v-if="isForeign"
          id="fileInput"
          ref="file"
          type="file"
          multiple
          style="display: none"
          accept="image/*,application/pdf"
          @change="setMultiplePhotos"
      >
      <Breadcrumbs :title="$t('companySearch.irktAxtar')"/>
      <div class="row">
        <div class="col-xl-8 ">
          <div
              v-if="showCreateForm"
              class="card"
          >
            <div class="card-body">
              <p class="lead">
                {{ $t('companySearch.yeniIrkt') }}
              </p>
              <form @submit.prevent="createCompany">
                <div class="row">
                  <div class="col-6 mb-3">
                    <label>{{ $t('companySearch.irktTipi') }}</label>
                    <select
                        v-model="legalForm"
                        class="form-control"
                        disabled
                    >
                      <option value="JURIDICAL_PERSON">
                        {{ $t('companyProfile.hquqiXs') }}
                      </option>
                      <option value="INDIVIDUAL">
                        {{ $t('companyProfile.fizikiXs') }}
                      </option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label>{{ $t('companyProfile.ven') }}</label>
                    <input
                        v-model="taxId"
                        type="number"
                        class="form-control"
                        disabled
                    >
                  </div>
                </div>

                <div class="row">
                  <div class="col-6 mb-3">
                    <label>{{ $t('companySearch.irktAd') }}</label>
                    <input
                        v-model="companyName"
                        type="text"
                        class="form-control"
                        required
                    >
                  </div>

                  <div class="col-6 mb-3">
                    <label>{{ $t('companySearch.tkilatFormas') }}</label>
                    <select
                        v-model="companyFormat"
                        class="form-control"
                        required
                    >
                      <option
                          v-for="(v,f) in getCompanyFormats()"
                          :key="v"
                          :value="f"
                      >
                        {{ v }}
                      </option>
                    </select>
                  </div>

                  <div
                      v-if="isForeign&&legalForm==='JURIDICAL_PERSON'"
                      class="col-6 mb-3"
                  >
                    <label>{{ $t('companySearch.legalEmailOfCompany') }}</label>
                    <input
                        v-model="email"
                        class="form-control"
                        :placeholder="$t('companySearch.enterYourEmail')"
                        @input="validateEmail"
                    >
                    <button
                        class="btn btn-sm"
                        :class="buttonClass"
                        :disabled="!emailIsValid"
                        style="margin-top: 10px; "
                        type="button"
                        @click="requestOtp"
                    >
                      {{ isOtpVerified ? 'Verified' : 'Verify Email' }}
                    </button>
                  </div>

                  <div v-if="legalForm==='JURIDICAL_PERSON'">
                    <div v-if="isForeign">
                      <div v-if="taxPhoto.length > 0">
                        <!-- Loop through each item in the taxPhoto array -->
                        <div
                            v-for="(photo, index) in taxPhoto"
                            :key="index"
                        >
                          <!-- Check if the photo is an image -->
                          <div v-if="!photo.includes('pdf')">
                            <img
                                :src="mediaBase + '/' + photo"
                                class="img-thumbnail cursor-pointer"
                                style="max-width: 100%; max-height: 200px;"
                                alt="taxPhoto"
                                @click.prevent="selectPhoto"
                            >
                          </div>
                          <!-- Check if the photo is a PDF -->
                          <div v-else>
                            <canvas
                                :id="`pdfThumbnail`+index"
                                class="img-thumbnail cursor-pointer"
                                style="max-width: 100%; max-height: 200px;"
                                @click.prevent="selectPhoto"
                            />
                          </div>
                        </div>
                      </div>
                      <!-- If no photos are uploaded -->
                      <div v-else>
                        <div
                            class="alert alert-primary text-center cursor-pointer"
                            style="padding: 50px 20px;"
                            @click.prevent="selectPhoto"
                        >
                          <feather
                              type="upload"
                              size="40"
                          />
                          <br>
                          {{ $t('companySearch.pleaseUpdateYourTinPhoto') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label>{{ $t('companySearch.faliyytSahlri') }}</label>


                  <div class="mt-1">
                    <button
                        v-b-modal.modal-sector-selection
                        type="button"
                        class="btn btn-sm btn-light-primary"
                    >
                      {{ $t('companyProfile.faliyytSahsiniSein') }}
                    </button>
                  </div>

                  <hr v-if="selectedSectors.length>0">
                  <SelectedSectorView
                      :sectors="selectedSectors"
                      :parent-id="0"
                  />

                  <span>
                    {{ $t('companySearch.irktinizinFaliyytSahlriniSein') }}
                  </span>
                </div>


                <div class="mb-3">
                  <button
                      type="submit"
                      :disabled="legalForm !== 'INDIVIDUAL' && ( countryCode === 'AZ' ? false : !isOtpVerified)"
                      class="btn btn-primary"
                  >
                    {{ $t('companySearch.irktYarat') }}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div
              v-else-if="resultCompany == null"
              class="card"
          >
            <div class="card-body">
              <p class="lead">
                {{ $t('companySearch.irktAxtar') }}
              </p>
              <form @submit.prevent="searchCompany">
                <div class="mb-3">
                  <label for="legalForm">{{ $t('companySearch.irktTipi') }}</label>
                  <select
                      id="legalForm"
                      v-model="legalForm"
                      class="form-control"
                      required
                  >
                    <option value="JURIDICAL_PERSON">
                      {{ $t('companyProfile.hquqiXs') }}
                    </option>
                    <option value="INDIVIDUAL">
                      {{ $t('companyProfile.fizikiXs') }}
                    </option>
                  </select>
                </div>

                <div class="mb-3">
                  <label for="taxId">{{ $t('companyProfile.ven') }}</label>
                  <input
                      id="taxId"
                      v-model="taxId"
                      type="number"
                      class="form-control"
                      required
                  >
                </div>

                <div class="mb-3">
                  <button
                      type="submit"
                      class="btn btn-primary"
                  >
                    {{ $t('companySearch.axtar') }}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div
              v-else
              class="card"
          >
            <div class="card-body">
              <div class="text-center">
                <img
                    :src="getPhoto(resultCompany.logo,'thumbnailCropped')"
                    class="img-thumbnail rounded-circle mb-3"
                    alt="img-thumbnail rounded-circle"
                    style="width: 200px;"
                >
                <h3>
                  {{ resultCompany.name }} {{ getCompanyFormat(resultCompany.format) }}
                </h3>
                <div class="lead">
                  {{ resultCompany.taxId }}
                </div>
              </div>

              <div
                  class="text-center"
                  style="margin-top: 60px;"
              >
                <router-link
                    class="btn btn-primary"
                    :to="`/dashboard/company/${resultCompany.id}`"
                >
                  {{ $t('companySearch.mnBurdaIlyirm') }}
                </router-link>
                <br>
                <button
                    type="button"
                    class="btn btn-link"
                    @click.prevent="resultCompany=null"
                >
                  {{ $t('companySearch.yeniAxtar') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
            v-if="!isForeign"
            class="col-xl-4 "
        >
          <div class="card">
            <div class="card-body">
              <p>
                <strong>{{ $t('companyProfile.ven') }}</strong>
              </p>
              <p>
                {{ $t('companySearch.irktinizinVeniniBilmirsinizsXahiEdirikBuLinkDaxilO') }}
              </p>

              <p>
                <a
                    class="btn btn-primary btn-sm"
                    href="https://www.e-taxes.gov.az/ebyn/commersialChecker.jsp"
                >
                  e-taxes.gov.az
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal
        id="modal-sector-selection"
        centered
        :title="$t('companyProfile.faliyytSahsiniSein')"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :hide-header-close="false"
        class="theme-modal"
        :busy="false"
        :hide-footer="true"
    >
      <SectorSelectionModal
          :min-selection="3"
          :max-selection="1000"
          :parent-sector="null"
          :selected="selectedSectors"
          @done="sectorSelected($event)"
      />
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import * as pdfjsLib from 'pdfjs-dist';
import {
  createCompany,
  generateOtp,
  getWorkingSectors,
  searchCompany,
  upload,
  verifyOtp
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {
  companyFormatListAZ,
  companyFormatListEN, companyFormatListRU,
  getCompanyFormat,
  getPhoto,
  getProfileName
} from "@/repositories/Utils";

import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import SectorSelectionModal from "/src/components/sector_selection_modal.vue";
import public_emails from "@/repositories/public_emails.json";

export default {
  components: {SelectedSectorView, SectorSelectionModal},
  data() {
    return {
      mediaBase: mediaBase,
      sectors: [],
      legalForm: '',
      taxId: '',
      uploadProgress: 0,
      taxPhoto: [],
      resultCompany: null,
      showCreateForm: false,
      companyName: '',
      legalEmail: '',
      isOtpVerified: false,
      email: '',
      emailIsValid: false,
      countryCode: '',
      companyFormat: '',
      isForeign: false,
      selectedSectors: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
    buttonClass() {
      return this.isOtpVerified ? 'btn-light-success' : 'btn-light-danger';
    },
  },

  mounted() {
    this.countryCode = localStorage.getItem('country');
    this.isForeign = this.countryCode !== 'AZ';
    getWorkingSectors(this.$i18n.locale).then(data => {
      this.sectors = data;
    })
  },
  methods: {
    generatePdfThumbnail(pdfUrl, index) {
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js'

      const loadingTask = pdfjsLib.getDocument(mediaBase + '/' + pdfUrl);

      loadingTask.promise.then(
          function (pdf) {
            return pdf.getPage(1); // Get the first page
          }
      ).then(function (page) {
        const scale = 1;
        const viewport = page.getViewport({scale: scale});

        // Use the index to get the correct canvas element
        const canvas = document.getElementById("pdfThumbnail" + index);
        console.log(canvas)
        if (!canvas) {
          return;
        }
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
          canvasContext: context,
          viewport: viewport,
        };
        page.render(renderContext);
      });
    },
    requestOtp() {
      generateOtp(this.email, this.token).then(response => {
            if (response.code === 1000) {
              this.$swal({
                title: this.$t("otp.title"),
                input: 'text',
                inputPlaceholder: this.$t("otp.placeHolder"),
                showCancelButton: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  verifyOtp(this.email, result.value, this.token).then(response => {
                        this.isOtpVerified = response.code === 1000
                      }
                  );
                }
              });
            }
          }
      )
    },
    validateEmail() {
      const emailFormat = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      this.emailIsValid = emailFormat.test(this.email) && !public_emails.some(provider => this.email.includes(provider));
    },
    selectPhoto() {
      window.document.getElementById('fileInput').click();
    },
    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'foreignTax', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {

                this.taxPhoto = response.data.path;
                if (currentFile.type === "application/pdf") {
                  // Generate PDF thumbnail
                  this.generatePdfThumbnail(response.data.path); // Assuming this.taxPhoto is accessible URL
                }
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {
              console.log(e);
              this.progress = 0;
              this.$swal({
                title: `Error `,
                text: this.$t("request.cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("request.photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },
    setMultiplePhotos() {
      let files = this.$refs.file.files;

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        Array.from(files).forEach((currentFile, index) => {
          upload(this.token, 'foreignTax', currentFile, event => {
            this.uploadProgress = Math.round((100 * event.loaded) / event.total);
          })
              .then(response => {
                this.uploadProgress = 100;

                if (response.data.code === 200) {
                  this.taxPhoto.push(response.data.path)
                  if (currentFile.type === "application/pdf") {
                    this.generatePdfThumbnail(response.data.path, index);
                  }

                } else {
                  this.$swal({
                    title: `Error ${response.data.code}`,
                    text: `${response.data.message}`,
                    icon: 'error'
                  });
                }

              })
              .catch((e) => {
                console.log(e);
                this.uploadProgress = 0; // Reset the progress
                this.$swal({
                  title: 'Error',
                  text: this.$t("request.cldNotUploadFile") + e,
                  icon: 'error'
                });
              });
        });
      } else {
        this.$swal({
          title: 'Error',
          text: this.$t("request.photoUploadNotSpprtdBrowser"),
          icon: 'error'
        });
      }
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormats() {
      switch (this.$i18n.locale) {
        case 'en':
          return companyFormatListEN;
        case 'ru':
          return companyFormatListRU;
        default:
          return companyFormatListAZ;
      }
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    sectorSelected(sectors) {
      this.selectedSectors = sectors;
      this.$bvModal.hide('modal-sector-selection');
    },
    searchCompany() {
      searchCompany(this.token, this.legalForm, this.taxId).then(data => {
        if (data.code === 200) {
          this.resultCompany = data.company;
        } else if (data.code === 404) {
          this.$swal({
            title: this.$t("companySearch.irktAxtar"),
            html: `${this.$t("companySearch.modalText", {taxId: this.taxId})}`,
            icon: 'question',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: this.$t("newPolRequest.bli"),
            cancelButtonText: this.$t("companySearch.yeniAxtar")
          }).then((result) => {
            console.log(result);
            if (result.value) {
              this.showCreateForm = true;
            }
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },
    createCompany() {
      let sectors = this.selectedSectors.map(function (elem) {
        return elem.id;
      }).join(",")

      createCompany(this.token,
          this.legalForm,
          this.taxId,
          this.companyName,
          this.companyFormat,
          sectors,
          this.email,
          this.taxPhoto,
          this.countryCode
      ).then(data => {
        if (data.code === 200) {
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: this.$t("companySearch.created"),
            icon: 'success'
          }).then(() => {
            this.$router.push(`/dashboard/company/${data.id}`);
          })
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
